import getUserReducers from './getUser/getUserReducers';
import clearUserReducers from './clearUser/clearUserReducers';
import deactivateUserReducers from './deactivateUser/deactivateUserReducers';
import getAddressesReducers from './getAddresses/getAddressesReducers';
import updateAddressReducers from './updateAddress/updateAddressReducers';
import getContactsReducers from './getContacts/getContactsReducers';
import updateContactReducers from './updateContact/updateContactReducers';
import updatePasswordReducers from './updatePassword/updatePasswordReducers';
import updateProfileInfoReducers from './updateProfileInfo/updateProfileInfoReducers';
import getAllSecurityQuestionsReducers from './getAllSecurityQuestions/getAllSecurityQuestionsReducers';
import getUserSecurityQuestionsReducers from './getUserSecurityQuestions/getUserSecurityQuestionsReducers';
import updateUserSecurityQuestionsReducers from './updateUserSecurityQuestions/updateUserSecurityQuestionsReducers';
import getTodoReducers from './getTodoItems/getTodoReducers';
import transactionsReducers from './transactions/transactionsReducers';
import subscriptionReducers from './subscriptions/subscriptionReducers';

const userReducers = {
  ...getUserReducers,
  ...clearUserReducers,
  ...deactivateUserReducers,
  ...getAddressesReducers,
  ...getContactsReducers,
  ...updateAddressReducers,
  ...updateContactReducers,
  ...updatePasswordReducers,
  ...updateProfileInfoReducers,
  ...getAllSecurityQuestionsReducers,
  ...getUserSecurityQuestionsReducers,
  ...updateUserSecurityQuestionsReducers,
  ...getTodoReducers,
  ...transactionsReducers,
  ...subscriptionReducers,
};

export default {
  name: 'user',
  reducers: userReducers,
};
